module.exports = __webpack_public_path__ + "img/certificates.c400e33f.jpg";